export default __webpack_public_path__ + "static/media/interactLogo.44e44a62.jpg";